module.exports = __webpack_public_path__ + "static/media/tech rider example 2 (stage plan).4d71e425.doc";